import PageTemplate from "./PageTemplate";
import Experience from "../../../Experience";
import Home from "./Home";

export default class Lab {
    constructor() {

        this.experience = new Experience()
        this.home = new Home()
        this.interaction = this.home.interaction
        this.resources = this.experience.resources



        if (this.resources.loaded === this.resources.toLoad) {
            this.setup()
        }
        else {
            this.resources.on("ready", () => {
                this.setup()
            })
        }
    }

    setup() {

        this.project1Image = this.resources.items.lorenzAttractor
        this.project2Image = this.resources.items.rayMarching2D
        this.project3Image = this.resources.items.sierpinskiTriangle
        this.project4Image = this.resources.items.flowfield
        this.project1 = {
            name: "Lorenz Attractor",
            image: this.project1Image,
            listDescription: "Lorenz Attractor",
            link: "https://lorenz-attractor-three.vercel.app/",
            detailedDescription: "Lorenz Attractor made with ThreeJS.\n\nF: Full Screen\nQ: Better quality\nM: Screenshot\nR: Restart\n\nTechnologies: ThreeJS, HTML, CSS, JS"
        }
        this.project2 = {
            name: "Ray Marching 2D",
            image: this.project2Image,
            listDescription: "2D implementation of Ray Marching.",
            link: "https://raymarching2d.vercel.app/",
            detailedDescription: "This is a Ray Marching test in 2D just to see how it works using WebGL.\n\nTechnologies: ThreeJS, HTML, CSS, JS, GLSL"
        }
        this.project3 = {
            name: "Sierpinski Triangle",
            image: this.project3Image,
            listDescription: "A scuffed Sierpinski Triangle",
            link: "https://sierpinski-eight.vercel.app/",
            detailedDescription: "This is an interactive Sierpinski Triangle Implementation and this was one of my first ThreeJS experiments.\n\nDouble click for full screen\nControls on the top right for changing configs\n\nTechnologies: ThreeJS, HTML, CSS, JS, GLSL"
        }
        this.project4 = {
            name: "Flow Field",
            image: this.project4Image,
            listDescription: "Flow Field with GLSL",
            link: "https://anotherflowfield.vercel.app/",
            detailedDescription: "Flowfield\n\nDouble click for full screen\n\nTechnologies: ThreeJS, HTML, CSS, JS, GLSL"
        }
        this.projectsList = [this.project4, this.project1, this.project3, this.project2]


        this.template = new PageTemplate(
            "Workshop",
            "#fe9a0d",
            "#8e6300",
            this.projectsList
        )
    }

    destroy() {
        this.template.destroy()
    }
}